import React, { useState, useContext } from "react";
import Header from '../../components/Header';
import TableComponent from '../../components/TableComponent';
import MultiSelectComponent from '../../components/MultiSelectComponent';
import DateRangePickerComponent from '../../components/DateRangePickerComponent';
import TextComponent from '../../components/TextComponent';
import Dashboard from '../../components/Dashboard';
import PageHeaderComponent from '../../components/PageHeaderComponent';
import { CubeJSContext } from '../../context/CubeJSProvider';
import OmnitechQueries from '../../queries/OmnitechQueries'
import { useTranslation } from 'react-i18next';
import { useCubeQuery } from '@cubejs-client/react';
import { setHours, setMinutes, setSeconds, setMilliseconds, format } from 'date-fns'

const applyFilter = (query, storeFilter) => {
  let storeCodeFilterObj = {
    member: "DiscountBreakdownCHE.shipFromStoreCode",
    operator: "equals",
    values: storeFilter
  }

  query = {
    ...query,
    filters: (query.filters || []).concat(storeCodeFilterObj)
  }

  return query
}

const DiscountBreakdownCHEHistQuery = (storeFilter, startDateFilter, endDateFilter, isRefresh, setRefresh) => {
  const { t } = useTranslation();
  if(startDateFilter == null && endDateFilter == null){
    startDateFilter = new Date()
    startDateFilter.setHours(0,0,0,0);
    endDateFilter = new Date()
    endDateFilter.setHours(23,59,59,999);
  }
  else if(startDateFilter == null){
    startDateFilter = setHours(endDateFilter, 0)
    startDateFilter = setMinutes(startDateFilter, 0)
    startDateFilter = setSeconds(startDateFilter, 0)
    startDateFilter = setMilliseconds(startDateFilter, 0)
  }
  else if (endDateFilter == null){
    endDateFilter = setHours(startDateFilter, 23)
    endDateFilter = setMinutes(endDateFilter, 59)
    endDateFilter = setSeconds(endDateFilter, 59)
    endDateFilter = setMilliseconds(endDateFilter, 999)
  }
  let item = {
    name: t('page.che.discountBreakDownCHEHistPage.name'),
    tableHeaders: {
      "DiscountBreakdownCHE.shipFromStoreCode": { name: t('page.che.discountBreakDownCHEHistPage.tableHeader.shipFromStoreCode'), type: 'string'},
      "DiscountBreakdownCHE.discountCode": { name: t('page.che.discountBreakDownCHEHistPage.tableHeader.discountCode'), type: 'string'},
      "DiscountBreakdownCHE.discountNameEnHk": { name: t('page.che.discountBreakDownCHEHistPage.tableHeader.discountNameEnHk'), type: 'string'},
      "DiscountBreakdownCHE.discountNameZhHk":  { name: t('page.che.discountBreakDownCHEHistPage.tableHeader.discountNameZhHk'), type: "string" },
      "DiscountBreakdownCHE.rsmrCode": { name: t('page.che.discountBreakDownCHEHistPage.tableHeader.rsmrCode'), type: 'string'},
      "DiscountBreakdownCHE.subcatCategoryCode":  { name: t('page.che.discountBreakDownCHEHistPage.tableHeader.subcatCategoryCode'), type: "string" },
      "DiscountBreakdownCHE.sumLineTotal": { name: t('page.che.discountBreakDownCHEHistPage.tableHeader.lineTotal'), type: 'number'},
      "DiscountBreakdownCHE.sumQuantity": { name: t('page.che.discountBreakDownCHEHistPage.tableHeader.quantity'), type: 'number'},
    },
    grid: {xs: 12},
    export: { allowExport: true, filename: 'discount_breakdown_export_' + format(startDateFilter, 'yyyyMMddHHmmss') +
      '_' + format(endDateFilter, 'yyyyMMddHHmmss') }
  }
  let query = {
    ...OmnitechQueries.mvOrderTransactions.DiscountBreakdownCHE.query,
    "timeDimensions": [
      {
        "dimension": "DiscountBreakdownCHE.ordersCompletedAt",
        "dateRange": [ startDateFilter, endDateFilter ]
      }
    ],
  }
  query = applyFilter(query, storeFilter)
  if(isRefresh)
    query = {}
  const result = useCubeQuery(query, {resetResultSetOnChange: true})
  if(isRefresh)
    setRefresh(false)
  return { item, result }
}

const DiscountBreakdownCHEHistPage = () => {
  const { t } = useTranslation();
   const context = useContext(CubeJSContext);
  let storeCodeSelect = []
  if(context.storeCodes)
    storeCodeSelect = context.storeCodes
  const [ storeFilter, setStoreFilter ] = useState([]);
  let filterStartDate = new Date()
  filterStartDate.setHours(0,0,0,0);
  let filterEndDate = new Date()
  filterEndDate.setHours(23,59,59,999);
  const [dateRangeFilter, setDateRangeFilter] = useState([filterStartDate, filterEndDate])
  const [startDateFilter, endDateFilter] = dateRangeFilter
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const [ refresh1, setRefresh1 ] = useState(false);

  const { item, result }  = DiscountBreakdownCHEHistQuery(storeFilter, startDateFilter, endDateFilter, refresh1, setRefresh1)

  const refresh = () => {
    setRefresh1(true)
    setPage(0)
  }

  return ([
    <Header />,
    <PageHeaderComponent onClickFunc={refresh} refreshlabel={t('component.refresh')} headerTitle={t('component.header.menu.discountBreakdownCHEReport')} />,
    <Dashboard>
      <MultiSelectComponent id={"store_code_filter"} state={storeFilter} pageChangerArr={[setPage]}
          stateChanger={setStoreFilter} textLabel={t('page.che.discountBreakDownCHEHistPage.filter.store.name')} selectArray={storeCodeSelect}/>
      <DateRangePickerComponent state={dateRangeFilter} stateChanger={setDateRangeFilter} pageChangerArr={[setPage]}
        startDateLabel={t('page.che.discountBreakDownCHEHistPage.filter.orderCompletedAt.startDate')} 
        toLabel={t('page.che.discountBreakDownCHEHistPage.filter.orderCompletedAt.to')} 
        endDateLabel={t('page.che.discountBreakDownCHEHistPage.filter.orderCompletedAt.endDate')}/>
    </Dashboard>
    ,
    <Dashboard>
      <TextComponent title={t('component.text.historical')} xs={12} />
      <TableComponent item={item} result={result} rowsPerPage={rowsPerPage} 
        setRowsPerPage={setRowsPerPage} page={page} setPage={setPage}/>
    </Dashboard>
  ]) 
};

export default DiscountBreakdownCHEHistPage;